<template>
  <BModal
    id="modalDelete"
    ref="modalDelete"
    no-close-on-esc
    no-close-on-backdrop
    hide-header-close
    hide-footer
    hide-header
    :centered="true"
    style="width: 600px;"
  >
    <div class="text-center my-1">
      <img
        src="https://storage.googleapis.com/komerce/core/icon-popup-warning.png"
        alt="Komerce"
        class="m-auto"
      >
      <div class="font-semibold text-2xl text-black my-[20px]">
        Hapus item ini?
      </div>
      <p class="text-black my-[20px]">
        Yakin untuk menghapus item ini?
      </p>
      <div class="flex justify-center">
        <BButton
          size="md"
          variant="outline-primary"
          class="mr-1"
          style="width: 160.5px"
          @click="$bvModal.hide('modalDelete')"
        >
          Batal
        </BButton>
        <BButton
          size="md"
          variant="primary"
          style="width: 160.5px"
          block
          :disabled="loadingSubmit"
          @click="$emit('submit')"
        >
          Submit
        </BButton>
      </div>
    </div>
  </BModal>
</template>

<script>
export default {
  props: {
    loadingSubmit: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
